import { Component, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { CdkDropList } from '@angular/cdk/drag-drop';

import { Rectangle } from '../../../widget-grid/models/Rectangle.model';
import { WidgetGridComponent } from '../../../widget-grid/components/grid/grid.component';
import {
  IChangeWidgetPosition,
  IContextMenuGridAction,
  IContextMenuGridEvent
} from '../../../prisma-xs/models/prisma-xs.model';
import { IArticle } from '../../../prisma-xs/models/article.model';
import { IUprightOnGrid } from '../../../prisma-xs/models/upright.model';
import { MenuContextComponent } from '../menu-context/menu-context.component';
import { NO_IMAGE } from '../../../shared/constants/app.constant';
import { IHighlightConfigurationArea } from '../../../enclosure/models/grid.model';

@Component({
    selector: 'app-prisma-xs-enclosure-grid',
    templateUrl: './enclosure-grid.component.html',
    styleUrls: ['./enclosure-grid.component.scss'],
    standalone: false
})
export class EnclosureGridComponent {

  @ViewChild('menuContextComponent') menuContextComponentEl: MenuContextComponent;
  @ViewChild('grid', {static: true}) grid: WidgetGridComponent;
  @Input() allArticles: IArticle[];

  @Input() showGrid: boolean;
  @Input() showCovers: boolean;
  @Input() cols: number;
  @Input() zoomLevel: number;
  @Input() rows: number;
  @Input() isArticleCopied: boolean;
  @Input() widgets: IArticle[];
  @Input() placedKits: IArticle[] = [];
  @Input() contextMenuActionType;
  @Input() uprights: IUprightOnGrid;
  @Input() articleCopied: IArticle;
  @Input() availablePlacingGrabbingArticleOnGrid = true;
  @Input() isEditableProject: boolean;
  @Input() set dropArea(area: IHighlightConfigurationArea) {
    if (!area) {
      return;
    }
    this.highlightArea(area.rectangle, area.color)
  }

  @Output() changeGridDimensions = new EventEmitter<void>();
  @Output() inputEvent = new EventEmitter<KeyboardEvent>();

  @Output() widgetChange = new EventEmitter();
  @Output() enterGrid = new EventEmitter();
  @Output() gridLeave = new EventEmitter();
  @Output() changeWidgetPosition = new EventEmitter<IChangeWidgetPosition>();
  @Output() list = new EventEmitter<CdkDropList>();
  @Output() selectWidget = new EventEmitter<IArticle>();
  @Output() contextMenuData = new EventEmitter<IContextMenuGridEvent>();
  @Output() contextMenuActionData = new EventEmitter<IContextMenuGridAction>();

  resetHighlights() {
    this.grid.resetHighlights();
  }

  isAreaObstructed(rectangle: Rectangle, options) {
    return this.grid.isAreaObstructed(rectangle, options);
  }

  highlightArea(rectangle: Rectangle, color?: string) {
    this.grid.highlightArea(rectangle, color);
  }

  onWidgetChange(event) {
    this.widgetChange.emit(event);
  }

  onError(img: HTMLImageElement) {
    img.src = NO_IMAGE;
  }

  enterOnGrid() {
    this.enterGrid.emit();
  }

  leaveGrid() {
    this.gridLeave.emit();
  }

  onWidgetPositionChange(widget, index, productType) {
    this.changeWidgetPosition.emit({ widget, index, productType });
  }

  onSelectWidget(article) {
    this.selectWidget.next(article);
  }

  onDragStart(article) {
    this.selectWidget.next(article);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  contextMenu(event: MouseEvent, userMenu: TemplateRef<any>, allowOpen: boolean, article?: IArticle) {
    if (!allowOpen) {
      return;
    }
    this.contextMenuData.emit({ event, article, userMenu });
  }

  contextMenuAction(action: IContextMenuGridAction) {
    this.contextMenuActionData.emit(action);
  }
}
